import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function WhatsApp() {
  const goToWs = () => {
    window.open("https://wa.me/+593996191709", "_blank");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "35px",
        right: "35px",
        textAlign: "end",
        color: "green",
        zIndex: "100",
        width: "100%",
      }}
    >
      <WhatsAppIcon style={{ transform: "scale(2.8)" }} onClick={goToWs} />
    </div>
  );
}

// Planes.propTypes = {
//   bgImage: PropTypes.node.isRequired,
//   title: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
// };

export default WhatsApp;
